import { render, staticRenderFns } from "./PaymentShow.vue?vue&type=template&id=03c00b88&scoped=true&"
import script from "./PaymentShow.vue?vue&type=script&lang=js&"
export * from "./PaymentShow.vue?vue&type=script&lang=js&"
import style0 from "./PaymentShow.vue?vue&type=style&index=0&id=03c00b88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c00b88",
  null
  
)

export default component.exports